import React from 'react';
import {
	H1 as H1Component,
	H2 as H2Component,
	H3 as H3Component,
	H4 as H4Component,
	H5 as H5Component,
	Large as LargeComponent,
	Regular as RegularComponent,
	Small as SmallComponent,
	Disclaimer as DisclaimerComponent,
	TypographyProps,
} from './Typography';

const Typography: React.FC<TypographyProps> & {
	H1: React.FC<TypographyProps>;
	H2: React.FC<TypographyProps>;
	H3: React.FC<TypographyProps>;
	H4: React.FC<TypographyProps>;
	H5: React.FC<TypographyProps>;
	Large: React.FC<TypographyProps>;
	Regular: React.FC<TypographyProps>;
	Small: React.FC<TypographyProps>;
	Disclaimer: React.FC<TypographyProps>;
} = ({ children, ...props }) => <Typography {...props}>{children}</Typography>;

Typography.H1 = H1Component;
Typography.H2 = H2Component;
Typography.H3 = H3Component;
Typography.H4 = H4Component;
Typography.H5 = H5Component;
Typography.Large = LargeComponent;
Typography.Large = LargeComponent;
Typography.Regular = RegularComponent;
Typography.Small = SmallComponent;
Typography.Disclaimer = DisclaimerComponent;
export default Typography;
